/* eslint-disable react-hooks/exhaustive-deps */

//TO DO:
/* ADiconar Editor HTML no campo Description

Adicionar seletor de imagens no campo imagem

Adicionar preenchimento automatio sugerido de SEO URL

 */
import {
  Box,
  Button,
  TextField,
  Stack,
  List,
  Tab,
  ListItem,
  ListItemText,
  Typography,
  Container,
  Alert,
} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { green } from "@mui/material/colors";
import SendIcon from "@mui/icons-material/Send";
//import DeleteIcon from "@mui/icons-material/Delete";
import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import api from "../../../../services/api";
import Swal from "sweetalert2";
import { AsyncPaginate } from "react-select-async-paginate";
import { inputsName } from "../../../../config/languageConst";
import { useLocation, useParams } from "react-router-dom";
import { TabContext, TabList, useTabContext } from "@mui/lab";
import { MultiValue } from "react-select";
import { LogTrackUser } from "../../../../types/log-track-user/log-track-user";
import Cookies from "js-cookie";

function TabPanel(props: any) {
  const { children, className, value, index, ...other } = props;

  const context = useTabContext();

  if (context === null) {
    throw new TypeError("No TabContext provided");
  }
  const tabId = context.value;

  return (
    <Typography
      component="div"
      role="tabpanel"
      padding="24px"
      hidden={value !== tabId}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      //visibility={value === tabId ? "visible" : "hidden"}
      {...other}
    >
      {children}
    </Typography>
  );
}

export default function EditCategory() {
  const regex = /\W|_/;
  const [compareseourl, setcompareseourl] = useState(false);
  const [inputSEOURLTemp, setInputSEOURLTemp] = useState("");

  const [inputTitle, setInputTitle] = useState<string[]>([]);
  const [inputSEOURL, setInputSEOURL] = useState<string[]>([]);

  inputTitle.length = inputsName.length;
  inputSEOURL.length = inputsName.length;

  const handleChangeInputTitle = (event: any) => {
    inputTitle[event.target.id] = event.target.value;
    setInputTitle(inputTitle);
  };

  const handleChangeSEOURL = (event: any) => {
    inputSEOURL[event.target.id] = event.target.value;
    setInputSEOURL(inputSEOURL);
    setInputSEOURLTemp(event.target.value);
  };

  const GenerateSEOURL = async () => {
    //setMessage(event.target.value);
    const seourl_temp = [];
    for (var i = 0; i < inputTitle.length; i++) {
      if (inputTitle[i]) {
        let language_code: string;
        switch (i) {
          case 0:
            language_code = "-en";
            break;
          case 1:
            language_code = "-pt";
            break;
          case 2:
            language_code = "-es";
            break;
          case 3:
            language_code = "-jp";
            break;
          default:
            language_code = "";
          // code block
        }
        inputSEOURL[i] = TitleToURL(inputTitle[i] + language_code);
        setInputSEOURL(inputSEOURL);
        seourl_temp.push(inputSEOURL[i]);
      }
    }
    setInputSEOURL(seourl_temp);
  };

  const TitleToURL = function (str: string) {
    str = str.replace(/^\s+|\s+$/g, ""); // trim
    str = str.toLowerCase();

    // remove accents, swap ñ for n, etc
    var from =
      "ÁÄÂÀÃÅČÇĆĎÉĚËÈÊẼĔȆĞÍÌÎÏİŇÑÓÖÒÔÕØŘŔŠŞŤÚŮÜÙÛÝŸŽáäâàãåčçćďéěëèêẽĕȇğíìîïıňñóöòôõøðřŕšşťúůüùûýÿžþÞĐđßÆa·/_,:;";
    var to =
      "AAAAAACCCDEEEEEEEEGIIIIINNOOOOOORRSSTUUUUUYYZaaaaaacccdeeeeeeeegiiiiinnooooooorrsstuuuuuyyzbBDdBAa------";
    for (var i = 0, l = from.length; i < l; i++) {
      str = str.replace(new RegExp(from.charAt(i), "g"), to.charAt(i));
    }

    str = str
      .replace(/[^a-z0-9 -]/g, "") // remove invalid chars
      .replace(/\s+/g, "-") // collapse whitespace and replace by -
      .replace(/-+/g, "-"); // collapse dashes

    return str;
  };

  useEffect(() => {
    if (regex.test(inputSEOURLTemp)) {
      setcompareseourl(true);
    } else {
      setcompareseourl(false);
    }
  }, [inputSEOURL]);
  const { id } = useParams<{ id: string }>();
  const [circularLoading, setCircularLoading] = useState(false);
  const [requestError, setRequestError] = useState(false);
  const [requestErrorData, setRequestErrorData] = useState([]);
  const [tabValue, setTabValue] = useState("1");

  //User Tracking Logging Section //////////////////////////////////////
  let [alreadySetLog, setAlreadySetLog] = useState(false);
  const location = useLocation();
  if (!alreadySetLog) {
    LogTrackUser(Cookies.get("username"), location.pathname);
    setAlreadySetLog(true as boolean);
  }
  ///////////////////////////////////////////////////////////////////
  const handleChangeTab = (event: React.SyntheticEvent, newValue: string) => {
    setTabValue(newValue);
  };
  const {
    register,
    reset,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [parent, setParent] = useState<{ id: number; name: string } | null>(
    null
  );
  // To show the initial value of the parent category name

  const handleChangeParent = (newvalue: string) => {
    //setParentName(newvalue);
    //setParentID(parent ? parent.id : null;);
  };

  const loadOptionsCategories = async (search: any, page: any) => {
    const results = await api.get(`/categories?page=${page}&search=${search}`);

    const hasMore = results.data.total_pages === results.data.current_page;

    // results.data.items.push({id: 0, name: ""})
    return {
      options: [{ id: 0, name: "No Parent Category" }, ...results.data.items],
      hasMore: !hasMore,
    };
  };
  const loadPageOptionsCategories = async (
    q: any,
    _prevOptions: any,
    { page }: any
  ) => {
    const { options, hasMore } = await loadOptionsCategories(q, page);
    return {
      options,
      hasMore,
      additional: {
        page: page + 1,
      },
    };
  };

  const loadOptionsAttributeGroups = async (search: any, page: any) => {
    const results = await api.get(
      `/attribute-groups?page=${page}&search=${search}`
    );
    const hasMore = results.data.total_pages === results.data.current_page;
    return {
      options: results.data.items,
      hasMore: !hasMore,
    };
  };

  const loadPageOptionsAttributeGroups = async (
    q: any,
    _prevOptions: any,
    { page }: any
  ) => {
    const { options, hasMore } = await loadOptionsAttributeGroups(q, page);
    return {
      options,
      hasMore,

      additional: {
        page: page + 1,
      },
    };
  };

  const [valueAttributeGroups, setValueAttributeGroups] = useState<
    { id: number; name: string }[]
  >([]);

  const onChangeAttributeGroups = async (
    newValue: MultiValue<{ id: number; name: string }>
  ) => {
    setValueAttributeGroups([...newValue]);
  };

  const fetchAttributeGroups = async () => {
    const response2 = await api.get(`categories/attributeGroups/${id}`);
    setAttributeGroups(response2.data);
  };

  const setAttributeGroups = async (attributes: any) => {
    attributes.map((input: any, index: number) => {
      const insert = { id: input.id, name: input.name };
      valueAttributeGroups.push(insert);
      setValueAttributeGroups(Array.from(new Set(valueAttributeGroups)));
      return setValueAttributeGroups(Array.from(new Set(valueAttributeGroups)));
    });
  };

  const loadOptionsAttributes = async (search: any, page: any) => {
    const results = await api.get(`/attributes?page=${page}&search=${search}`);
    const hasMore = results.data.total_pages === results.data.current_page;
    return {
      options: results.data.items,
      hasMore: !hasMore,
    };
  };

  const loadPageOptionsAttributes = async (
    q: any,
    _prevOptions: any,
    { page }: any
  ) => {
    const { options, hasMore } = await loadOptionsAttributes(q, page);
    return {
      options,
      hasMore,

      additional: {
        page: page + 1,
      },
    };
  };

  const [valueAttributes, setValueAttributes] = useState<
    { id: number; name: string }[]
  >([]);
  const onChangeAttributes = async (
    newValue: MultiValue<{ id: number; name: string }>
  ) => {
    setValueAttributes([...newValue]);
  };
  const fetchAttributes = async () => {
    const response2 = await api.get(`categories/attributes/${id}`);
    setAttributes(response2.data);
  };

  const setAttributes = async (attributes: any) => {
    attributes.map((input: any, index: number) => {
      const insert = { id: input.id, name: input.name };
      valueAttributes.push(insert);
      setValueAttributes(Array.from(new Set(valueAttributes)));
      return setValueAttributes(Array.from(new Set(valueAttributes)));
    });
  };

  const onSubmit = (category: any) => {
    setCircularLoading(true);
    //let temp = [];
    for (let index = 0; index < category.descriptions.length; index++) {
      category.descriptions[index].category_id = Number(id);
      category.descriptions[index].language_id = Number(
        category.descriptions[index].language_id
      );
      category.descriptions[index].updated_at = new Date().toISOString();
      if (category.descriptions[index].seo_url === "") {
        category.descriptions[index].seo_url = null;
      }
    }
    category.id = Number(id);

    if (parent) {
      if (parent.id !== 0) {
        category.parent_id = parent ? parent.id : null;
      } else {
        category.parent_id = null;
      }
    }

    //Verify if the Parent Category is the same as the Category itself
    if (category.parent_id === category.id) {
      setCircularLoading(false);
      setRequestError(true);
      Swal.fire({
        title: "Parent Category CANNOT be the same as the category itself!",
        icon: "error",
        confirmButtonText: "NO",
      });
      return;
    }

    category.updated_at = new Date().toISOString();

    //Attribute Groups/ Filters
    let uniq_attribute_groups = valueAttributeGroups;
    let uniq_attribute_groups_ids = [];
    for (let index = 0; index < uniq_attribute_groups.length; index++) {
      uniq_attribute_groups_ids.push(Number(uniq_attribute_groups[index].id));
    }
    category.attribute_group_ids = uniq_attribute_groups_ids;

    //Attributes/Filters
    let uniq_attributes = valueAttributes;
    let uniq_attributes_ids = [];
    for (let index = 0; index < uniq_attributes.length; index++) {
      uniq_attributes_ids.push(Number(uniq_attributes[index].id));
    }
    category.attribute_ids = uniq_attributes_ids;
    api
      .put(`categories/${id}`, category)
      .then((res) => {
        setCircularLoading(false);
        setRequestError(false);
        Swal.fire({
          title: "Category Updated!",
          icon: "success",
          confirmButtonText: "Yes",
        });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "" + error.response.data.message,
          // footer: '<a href="">Why do I have this issue?</a>',
        });
        setCircularLoading(false);
        setRequestError(false);
        setRequestErrorData(error.response.data.message);
      });
  };

  const defaultAdditional = {
    page: 1,
  };

  const fetchCategory = async () => {
    const response = await api.get(`categories-custom/${id}`);
    reset(response.data);
    if (response.data.parent_id) {
      const insert = {
        id: response.data.parent.id,
        name: response.data.parent.name,
      };
      setParent(insert);
    }

    for (var i = 0; i < response.data.descriptions.length; i++) {
      inputSEOURL[i] = response.data.descriptions[i].seo_url;
      setInputSEOURL(inputSEOURL);
      inputTitle[i] = response.data.descriptions[i].name;
      setInputTitle(inputTitle);
    }
  };

  useEffect(() => {
    fetchCategory();
    fetchAttributes();
    fetchAttributeGroups();

    if (parent) {
      reset({
        parent_id: parent ? parent.id : null,
      });
    }
    //}, [parent]);
  }, []);

  return (
    <Container component="main" maxWidth="xl">
      <div style={{ marginTop: "100px" }}></div>
      <Typography
        component="h1"
        variant="h5"
        sx={{ fontSize: "32px", marginBottom: "15px", color: "#556cd6" }}
      >
        Edit Category {id}
      </Typography>
      {requestError && (
        <List component="nav" aria-label="errors">
          {requestErrorData.map((error) => (
            <ListItem key={error}>
              <ListItemText
                sx={{
                  color: "red",
                }}
                primary={error}
              />
            </ListItem>
          ))}
        </List>
      )}

      <TabContext value={tabValue}>
        <Box
          sx={{
            borderBottom: 1,
            borderColor: "divider",
            maxWidth: "xl",
            minWidth: 3 / 4,
          }}
        >
          <TabList onChange={handleChangeTab} centered aria-label="Tabs">
            <Tab label="Edit Category" value="1" />
            <Tab label="Attributes" value="2" />
          </TabList>
        </Box>
        <Box
          component="form"
          sx={{ mt: 1, minWidth: 3 / 4 }}
          onSubmit={handleSubmit(onSubmit)}
        >
          <TabPanel
            value="1"
            sx={{
              width: "100%",
              typography: "body1",
              maxWidth: "xl",
              minWidth: 3 / 4,
              alignItems: "center",
            }}
          >
            <Box sx={{ width: "100%", typography: "body1" }}>
              <AsyncPaginate
                placeholder="Select Parent Category"
                styles={{
                  menu: (provided) => ({
                    ...provided,
                    zIndex: 9999,
                  }),
                }}
                additional={defaultAdditional}
                key={"parent_id"}
                name="parent"
                id="parent"
                getOptionValue={(option: any) => option?.id}
                getOptionLabel={(option: any) => option?.name}
                loadOptions={loadPageOptionsCategories}
                onChange={setParent}
                value={parent}
                //inputValue = {parentname}
                onInputChange={handleChangeParent}
              />

              <div style={{ marginTop: "30px" }}>
                <Button variant="contained" href="" onClick={GenerateSEOURL}>
                  Generate SEO URLs
                </Button>
                {inputsName.map((input, index) => (
                  <div
                    key={index}
                    className="flags-container"
                    style={{ display: "block", marginTop: "50px" }}
                  >
                    <div className="fa-flags">
                      <img
                        src={`/assets/language/${input.language_id}.png`}
                        alt=""
                      />
                      &nbsp;-&nbsp;{input.language_name}
                    </div>
                    <input
                      hidden
                      {...register(`descriptions[${index}].language_id`, {
                        required: `descriptions[${index}].language_id is required`,
                      })}
                      value={input.language_id}
                    />

                    <TextField
                      sx={{ mt: 1, minWidth: 3 / 4 }}
                      InputLabelProps={{ shrink: true }}
                      margin="normal"
                      required
                      fullWidth
                      id={index.toString()}
                      type="text"
                      label="Name"
                      {...register(`descriptions[${index}].name`)}
                      onChange={handleChangeInputTitle}
                    />

                    {inputSEOURL[index] && (
                      <p>
                        Suggested New SEO URL: (Copy and Paste in the box below
                        to change the SEO URL) {inputSEOURL[index]}
                      </p>
                    )}
                    <br />

                    <TextField
                      sx={{ mt: 1, minWidth: 3 / 4 }}
                      InputLabelProps={{ shrink: true }}
                      margin="normal"
                      fullWidth
                      id={index.toString()}
                      type="text"
                      label="SEO URL (Friendly URL)"
                      {...register(`descriptions[${index}].seo_url`)}
                      onChange={handleChangeSEOURL}
                    />
                    {compareseourl && (
                      <Alert severity="warning">
                        Warning: caracteres specials are forbidden
                      </Alert>
                    )}

                    <TextField
                      sx={{ mt: 1, minWidth: 3 / 4 }}
                      InputLabelProps={{ shrink: true }}
                      margin="normal"
                      fullWidth
                      id={"#descriptions[" + index + "].image"}
                      type="text"
                      label="Image URL (relative path)"
                      {...register(`descriptions[${index}].image`)}
                    />

                    <TextField
                      InputLabelProps={{ shrink: true }}
                      margin="normal"
                      fullWidth
                      id={"#descriptions[" + index + "].content_html"}
                      type="text"
                      label="Description (Do not use HTML format)"
                      rows={10}
                      multiline
                      {...register(`descriptions[${index}].content_html`)}
                    />

                    <TextField
                      InputLabelProps={{ shrink: true }}
                      margin="normal"
                      fullWidth
                      id={"#descriptions[" + index + "].meta_keyword"}
                      type="text"
                      label="Meta keyword (Keywords for SEO - Write Everything related to the Category separated by commas. Max of 2000 Characters)"
                      rows={3}
                      multiline
                      {...register(`descriptions[${index}].meta_keyword`)}
                    />
                  </div>
                ))}
              </div>
            </Box>
          </TabPanel>

          <TabPanel
            value="2"
            sx={{
              width: "100%",
              typography: "body1",
              maxWidth: "xl",
              minWidth: 3 / 4,
              alignItems: "center",
            }}
          >
            <Box sx={{ width: "100%", typography: "body1" }}>
              <AsyncPaginate
                isMulti
                closeMenuOnSelect={false}
                blurInputOnSelect={false}
                placeholder="Select Attributes Groups/Filter Groups"
                styles={{
                  menu: (provided) => ({
                    ...provided,
                    zIndex: 9999,
                  }),
                }}
                additional={defaultAdditional}
                key={"attribute_group_ids"}
                id="attribute"
                name="attribute"
                getOptionValue={(option: any) => option?.id}
                getOptionLabel={(option: any) => option?.name}
                loadOptions={loadPageOptionsAttributeGroups}
                value={valueAttributeGroups}
                onChange={onChangeAttributeGroups}
              />

              {valueAttributeGroups.map((input, index) => {
                return (
                  <p>
                    {" "}
                    Attribute Group ID: {input.id} / {input.name}
                  </p>
                );
              })}

              <div style={{ marginTop: "50px" }}></div>

              <AsyncPaginate
                isMulti
                closeMenuOnSelect={false}
                blurInputOnSelect={false}
                placeholder="Select Attributes/Filters"
                styles={{
                  menu: (provided) => ({
                    ...provided,
                    zIndex: 9999,
                  }),
                }}
                additional={defaultAdditional}
                key={"attribute_ids"}
                id="attribute"
                name="attribute"
                getOptionValue={(option: any) => option?.id}
                getOptionLabel={(option: any) => option?.name}
                loadOptions={loadPageOptionsAttributes}
                value={valueAttributes}
                onChange={onChangeAttributes}
              />

              {valueAttributes.map((input, index) => {
                return (
                  <p>
                    {" "}
                    Attribute ID: {input.id} / {input.name}
                  </p>
                );
              })}
            </Box>
          </TabPanel>

          <p style={{ color: "red", textAlign: "center" }}>
            {errors?.descriptions?.toString()}
          </p>

          <Stack
            direction="row"
            spacing={2}
            sx={{
              mt: 2,
            }}
          >
            {/* <Button
                onClick={() => reset()}
                variant="outlined"
                startIcon={<DeleteIcon />}
                >
                Clear
                </Button> */}

            <Button
              size="large"
              sx={{ marginTop: "10px", marginBottom: "10px" }}
              href="/categories"
            >
              Back
            </Button>
            <Button
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
              size="large"
              endIcon={<SendIcon />}
              disabled={circularLoading}
              type="submit"
            >
              Send
              {circularLoading && (
                <CircularProgress
                  size={24}
                  sx={{
                    color: green[500],
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    marginTop: "-12px",
                    marginLeft: "-12px",
                  }}
                />
              )}
            </Button>
          </Stack>
        </Box>
      </TabContext>
    </Container>
  );
}
